import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  TextField,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { Fragment, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import LibraryAddCheckRoundedIcon from "@mui/icons-material/LibraryAddCheckRounded";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import { getSitesData } from "../../../apis/AlertGeneration";
const CBEWSL_SITE_LOCATION = process.env.REACT_APP_SITE_LOCATION;
const CBEWSL_SITE_NAME = process.env.REACT_APP_SITE_NAME;

function DisseminateModal(props) {
  const {
    isOpen,
    disseminateData,
    setOpenModal,
    handleSendSMS,
    monitoringReleases,
    setMonitoringReleases,
    setTriggers,
    triggers,
    capitalizeFirstLetter,
    ewiTemplates,
  } = props;

  const navigate = useNavigate();
  const [latest_triggers, setLatestTriggers] = [];
  const [message, setMessage] = useState("");
  const [copyMessage, setCopyMessage] = useState("");
  const [copyStatus, setCopyStatus] = useState(false);
  const [alertLevel, setAlertLevel] = useState("");
  const [siteLocation, setSiteLocation] = useState("");
  const [currentAlertTs, setCurrentAlertTs] = useState("");
  const [triggerSource, setTriggerSource] = useState([]);
  const [barangayRP, setBarangayRP] = useState("");
  const [communityRP, setCommunityRP] = useState("");
  const [lewcRP, setLewcRP] = useState("");
  const [municipalRP, setMunicipalRp] = useState("");
  const [provincialRp, setProvincialRp] = useState("");
  const [latestEventTriggers, setLatestEventTriggers] = useState([]);
  const [openAddInfo, setOpenAddInfo] = useState(false);
  const [infoMessage, setInfoMessage] = useState("");
  const [households, setHouseholds] = useState("");
  const [siteCode, setSiteCode] = useState("");

  const releaseEWISms = () => {
    handleSendSMS(message);
  };

  const onCopyText = () => {
    handleSendSMS(message, true)
    setCopyStatus(true);
    setTimeout(() => setCopyStatus(false), 2000);
  };

  const handleOpenAddInfo = () => {
    setOpenAddInfo(true);
  };

  const handleCloseAddInfo = () => {
    setOpenAddInfo(false);
    setInfoMessage("");
  };

  const handleAddInfoChange = (event) => {
    setInfoMessage(event.target.value);
  };

  const handleSaveAddInfo = () => {
    const sourceIndex = message.indexOf("\nSource:");
    const newMessage =
      message.slice(0, sourceIndex) +
      `\nAdditional Information: ${infoMessage}\n` +
      message.slice(sourceIndex);
    setMessage(newMessage);
    setCopyMessage(newMessage);
    console.log("Additional Information:", infoMessage);
    setOpenAddInfo(false);
    setInfoMessage("");
  };

  useEffect(() => {
    if (siteCode) {
      getSitesData((results) => {
        const site = results.find((site) => site.site_code === siteCode);
        if (site) {
          setHouseholds(site.households);
        }
      });
    }
  }, [siteCode]);

  useEffect(() => {
    if (disseminateData) {
      const { public_alert_level } = disseminateData;
      if (public_alert_level !== 0) {
        let data_timestamp;
        let site_location;
        const {
          event,
          public_alert_symbol,
          releases,
          latest_event_triggers,
          is_onset_release,
        } = disseminateData;
        const { site } = event;
        const { barangay, municipality, province, site_code } = site;
        const { data_ts, release_time } = releases[0];
        data_timestamp = data_ts;
        if (is_onset_release) {
          const temp_data_ts = data_ts;
          const temp_release_time = release_time;
          const onset_data_ts = `${moment(data_ts).format(
            "YYYY-MM-DD"
          )} ${temp_release_time}`;
          const onset_hour = moment(data_ts).hour();
          if (onset_hour === 23) {
            data_timestamp = moment(onset_data_ts).add(1, "days");
          }
        }
        const { alert_level } = public_alert_symbol;

        site_location = `Brgy. ${barangay}, ${municipality}, ${province}`;
        setSiteLocation(site_location);
        setSiteCode(site_code);

        let msg = `CBEWS-L EARLY WARNING INFORMATION\n\nAlert level: ${alert_level}\nLokasyon: ${site_location}\nPetsa at oras: ${moment(
          data_timestamp
        )
          .add(30, "minutes")
          .format("MMMM D, YYYY, h:mm A")}`;

        setAlertLevel(`Alert level ${alert_level}`);
        setCurrentAlertTs(
          moment(data_timestamp).add(30, "minutes").format("LLL")
        );

        let temp = [...triggerSource];
        if (alert_level > 0) {
          setLatestEventTriggers(latest_event_triggers);
          latest_event_triggers.forEach((trigger) => {
            const { internal_sym, trigger_misc, info, ts } = trigger;
            const { trigger_symbol } = internal_sym;
            const { trigger_hierarchy, alert_level } = trigger_symbol;
            const { trigger_source } = trigger_hierarchy;
            let template = ewiTemplates.find(
              (e) =>
                e.alert_level === alert_level && e.trigger === trigger_source
            );
            if (trigger_source === "on demand") {
              const { on_demand } = trigger_misc;
              const { eq_id } = on_demand;
              if (eq_id) {
                template = ewiTemplates.find(
                  (e) =>
                    e.alert_level === alert_level && e.trigger === "earthquake"
                );
              } else {
                template = ewiTemplates.find(
                  (e) =>
                    e.alert_level === alert_level && e.trigger === "rainfall"
                );
              }
              const trig_source = eq_id
                ? "On-demand Earthquake"
                : "On-demand Rainfall";
              msg += `\nBakit (${capitalizeFirstLetter(trig_source)}): ${
                template.sms_trigger_description
              }`;
              temp.push({
                source: capitalizeFirstLetter(trig_source),
                description: template.trigger_description,
                info,
                latest_ts: ts,
              });
            } else {
              const trig_source =
                trigger_source === "moms"
                  ? "Landslide Features"
                  : trigger_source;
              msg += `\nBakit (${capitalizeFirstLetter(trig_source)}): ${
                template.sms_trigger_description
              }`;

              temp.push({
                source: capitalizeFirstLetter(trig_source),
                description: template.trigger_description,
                info,
                latest_ts: ts,
              });
              setTriggerSource(temp);
            }
          });
        }
        const recommended_response = ewiTemplates.find(
          (e) => e.alert_level === alert_level
        );
        setBarangayRP(recommended_response.barangay_response);
        setLewcRP(recommended_response.lewc_response);
        setCommunityRP(recommended_response.community_response);
        setMunicipalRp(recommended_response.mlgu_response);
        setProvincialRp(recommended_response.plgu_response);

        msg += `\n\nResponde (Komunidad): ${recommended_response.sms_community_response}\n`;
        msg += `\nResponde (LEWC): ${recommended_response.sms_lewc_response}\n`;
        msg += `\nResponde (BLGU): ${recommended_response.sms_barangay_response}\n\n`;
        msg += `Source: MDRRMO Alimodian`;
        setMessage(msg);
        setCopyMessage(msg);
      } else {
        // need icheck if gagana din sa extended
        const { data_ts, public_alert_level, site_code, isRoutine } =
          disseminateData;
        const recommended_response = ewiTemplates.find(
          (e) => e.alert_level === public_alert_level
        );
        let site_location = CBEWSL_SITE_LOCATION;
        setSiteLocation(site_location);
        let msg = `CBEWS-L EARLY WARNING INFORMATION\n\nAlert Level: ${
          recommended_response.alert_level
        }\nLokasyon: ${site_location}\nPetsa at oras: ${moment(data_ts)
          .add(30, "minutes")
          .format("MMMM D, YYYY, h:mm A")}`;

        setAlertLevel(`Alert Level ${recommended_response.alert_level}`);
        setCurrentAlertTs(moment(data_ts).add(30, "minutes").format("LLL"));

        let temp = [...triggerSource];
        if (isRoutine === false) {
          temp.push({
            source: "Extended",
            description: recommended_response.trigger_description,
          });
        }
          setSiteCode(site_code);
          setTriggerSource(temp);
          setCommunityRP(recommended_response.community_response);
          setBarangayRP(recommended_response.barangay_response);
          setLewcRP(recommended_response.lewc_response);
          setMunicipalRp(recommended_response.mlgu_response);
          setProvincialRp(recommended_response.plgu_response);

          msg += `\nBakit: ${recommended_response.sms_trigger_description}`;
          msg += `\n\nResponde (Komunidad): ${recommended_response.sms_community_response}\n\nResponde (LEWC): ${recommended_response.sms_lewc_response}\n\nResponde (BLGU): ${recommended_response.sms_barangay_response}\n\nSource: MDRRMO Alimodian`;
          setMessage(msg);
          setCopyMessage(msg);
      }
    }
  }, [disseminateData]);

  const renderBulletin = () => {
    navigate(`/bulletin`, {
      state: {
        alertLevel: alertLevel,
        siteLocation: siteLocation,
        currentAlertTs: currentAlertTs,
        triggerSource: triggerSource,
        barangayRP: barangayRP,
        communityRP: communityRP,
        lewcRP: lewcRP,
        municipalRP,
        provincialRp,
        triggerList: latestEventTriggers,
        households: households,
      },
    });
  };

  const sendEwiSMS = () => {
    setOpenModal(false);
    handleSendSMS(message);
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        fullScreen={false}
        open={isOpen}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <Grid container>
            <Grid item md={6}>
              <Typography variant="h6">Disseminate Warning</Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item md={12}>
              <TextField
                id="filled-multiline-static"
                label="Message"
                multiline
                rows={25}
                variant="filled"
                value={message}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container justifyContent="center" alignItems="flex-start">
            <Grid container item md={4}>
              <Tooltip title="Insert additional information">
                <IconButton
                  color="primary"
                  size="large"
                  onClick={handleOpenAddInfo}
                >
                  <NoteAddIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
              <CopyToClipboard text={copyMessage} onCopy={onCopyText}>
                <Tooltip
                  title={
                    copyStatus
                      ? "EWI copied to clipboard!"
                      : "Copy to Clipboard"
                  }
                >
                  <IconButton color="primary" size="large">
                    {copyStatus ? (
                      <LibraryAddCheckRoundedIcon fontSize="inherit" />
                    ) : (
                      <ContentCopyRoundedIcon fontSize="inherit" />
                    )}
                  </IconButton>
                </Tooltip>
              </CopyToClipboard>
            </Grid>
            <Grid
              container
              item
              md={8}
              justifyContent="flex-end"
              alignItems="center"
            >
              <Button
                variant="contained"
                onClick={() => setOpenModal(false)}
                color="error"
                // style={{marginRight: 10}}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                onClick={() => {
                  handleSendSMS(message, false)
                  renderBulletin();
                }}
                color="primary"
                style={{ marginLeft: 10, marginRight: 15 }}
              >
                Generate Bulletin
              </Button>
            </Grid>
          </Grid>
          {/* <Button
            variant="contained"
            onClick={() => {
              sendEwiSMS();
            }}
            color="primary"
          >
            Send EWI SMS
          </Button> */}
          {/* <Button 
                variant="contained"
                onClick={handleOpenAddInfo}
              >
                Insert additional information
          </Button> */}
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAddInfo}
        onClose={handleCloseAddInfo}
        fullScreen={false}
        fullWidth={true}
        maxWidth="xs"
      >
        <DialogTitle>Insert additional information</DialogTitle>
        <DialogContent>
          <TextField
            id="filled-basic"
            variant="filled"
            multiline
            fullWidth
            rows={15}
            value={infoMessage}
            onChange={handleAddInfoChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={handleCloseAddInfo}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSaveAddInfo}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

export default DisseminateModal;
